/* tslint:disable */

declare var Object: any;
export interface UsuarioSucursalInterface {
  "idusuariosucursal"?: number;
  "idsucursal"?: number;
  "idusuario"?: number;
  "fechacreacion"?: Date;
  "idusuarioempresamongo"?: string;
}

export class UsuarioSucursal implements UsuarioSucursalInterface {
  "idusuariosucursal": number;
  "idsucursal": number;
  "idusuario": number;
  "fechacreacion": Date;
  "idusuarioempresamongo": string;
  constructor(data?: UsuarioSucursalInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `UsuarioSucursal`.
   */
  public static getModelName() {
    return "UsuarioSucursal";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of UsuarioSucursal for dynamic purposes.
  **/
  public static factory(data: UsuarioSucursalInterface): UsuarioSucursal{
    return new UsuarioSucursal(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'UsuarioSucursal',
      plural: 'UsuarioSucursals',
      path: 'UsuarioSucursals',
      idName: 'idusuariosucursal',
      properties: {
        "idusuariosucursal": {
          name: 'idusuariosucursal',
          type: 'number'
        },
        "idsucursal": {
          name: 'idsucursal',
          type: 'number'
        },
        "idusuario": {
          name: 'idusuario',
          type: 'number'
        },
        "fechacreacion": {
          name: 'fechacreacion',
          type: 'Date'
        },
        "idusuarioempresamongo": {
          name: 'idusuarioempresamongo',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/models/UsuarioSucursal.ts